<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
               <!-- {{year}} © Shri Mahakaleshwar. -->
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Powered By Brain Above InfoSol PVT LTD
                </div>
            </div>
        </div>
    </div>
</footer>